import NewSlideshow from '../../classes/NewSlideshow';

export const initSlideshowVariable = () => {
	const sliders = document.querySelectorAll( 'section.slideshow-variable div.new-slider' );

	if ( !sliders.length )
	{
		return;
	}

	Array.from( sliders ).forEach( ( it ) => {
		const sliderInstance = new NewSlideshow( { 
			element: it,
			loop: true
		} );
	
		sliderInstance.init();
	} );
};